// Navbar.jsx
import React from 'react';
import navbarStyles from './Navbar.module.css'
import {Link, useNavigate} from "react-router-dom";
import benefitLogo from '../../assets/img/benefit-logo.png'

import { NavLink } from 'react-router-dom'; // ezt ne felejtsd el importálni!
export function Navbar({user}) {
    return (
            <div className={"d-flex justify-content-between align-items-center p-3 "+navbarStyles.container}>
                <img style={{ height: '50px', width: '250px' }} src={benefitLogo} alt="Logo" />
                <span>{user?.username}</span>
                <ul className="d-flex list-unstyled gap-3">
                    <li><Link to="/">Főoldal</Link></li>
                    <li><Link to="/users">Felhasználók</Link></li>
                    {!user && <li><Link to="/login">Bejelentkezés</Link></li>}
                    {user && <li><Link to="/logout">Kijelentkezés</Link></li>}
                </ul>
            </div>
    );
}


export function BenefitShareNavbar(){
    const navigate = useNavigate();

    return (
        <header className="">
            <nav className="navbar navbar-expand-lg header-transparent bg-transparent header-reverse glass-effect"
                 data-header-hover="light">
                <div className="container-fluid">
                    <div className="col-auto col-xxl-3 col-lg-2 me-lg-0 me-auto"><a className="navbar-brand"
                                                                                    onClick={()=>navigate('/')}>
                        <img src="/benefitshare/img/demo-it-business-logo-white.png"
                             data-at2x="./benefitshare/img/demo-it-business-logo-white@2x.png" alt="" className="default-logo"/>
                        <img src="/benefitshare/img/demo-it-business-logo-black.png"
                             data-at2x="/benefitshare/img/demo-it-business-logo-black@2x.png" alt="" className="alt-logo"/> <img
                        src="/benefitshare/img/demo-it-business-logo-black.png"
                        data-at2x="/benefitshare/img/demo-it-business-logo-black@2x.png" alt="" className="mobile-logo"/> </a>
                    </div>
                    <div className="col-auto col-xxl-6 col-lg-8 menu-order position-static">
                        <button className="navbar-toggler float-start collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#navbarNav" aria-controls="#navbarNav-clone"
                                aria-label="Toggle navigation" data-target="#navbarNav-clone" aria-expanded="false">
                            <span className="navbar-toggler-line"></span> <span className="navbar-toggler-line"></span>
                            <span className="navbar-toggler-line"></span> <span className="navbar-toggler-line"></span>
                        </button>
                        <div className="collapse navbar-collapse justify-content-center" id="navbarNav" style={{cursor:"pointer"}}>

                            <ul className="navbar-nav">
                                {/* Programok */}
                                <li className="nav-item">
                                    <NavLink
                                        to="/programok" // ez a route
                                        className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} // active class hozzáadása automatikusan
                                    >
                                        Programok
                                    </NavLink>
                                </li>

                                {/* Előadók */}
                                <li className="nav-item">
                                    <NavLink
                                        to="/eloadok"
                                        className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                                    >
                                        Előadók
                                    </NavLink>
                                </li>

                                {/* Kiállítók */}
                                <li className="nav-item">
                                    <NavLink
                                        to="/kiallitok"
                                        className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                                    >
                                        Kiállítók
                                    </NavLink>
                                </li>

                                {/* Jegyek */}
                                <li className="nav-item">
                                    <NavLink
                                        to="/jegyek"
                                        className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                                    >
                                        Jegyek
                                    </NavLink>
                                </li>

                                {/* Kapcsolat */}
                                <li className="nav-item">
                                    <NavLink
                                        to="/kapcsolat"
                                        className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                                    >
                                        Kapcsolat
                                    </NavLink>
                                </li>

                                {/* Sajtó */}
                                <li className="nav-item">
                                    <NavLink
                                        to="/sajto"
                                        className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                                    >
                                        Sajtó
                                    </NavLink>
                                </li>

                                {/* Galéria */}
                                <li className="nav-item">
                                    <NavLink
                                        to="/galeria"
                                        className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                                    >
                                        Galéria
                                    </NavLink>
                                </li>
                            </ul>

                        </div>
                    </div>
                    <div className="col-auto col-xxl-3 col-lg-2 text-end d-none d-sm-flex">
                        <div className="header-icon">
                            <div className="header-button"><a
                                href="/jegyek"
                                className="border-1 btn btn-gradient-light-pink-light-purple btn-large btn-rounded text-transform-none">JEGYVÁSÁRLÁS</a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    )

}